import { permissionsByEntity, useCheckPermissions } from '@cmg/auth';

export const useCanManageDemandAnalyticsUpload = (): boolean =>
  useCheckPermissions([permissionsByEntity.DemandAnalyticsUpload.FULL]);
